import { useQuery } from 'react-query';
import { getStagesDescription } from '../index';
export const useGetStagesDescription = (guid) => useQuery('GetStagesDescription', () => getStagesDescription(guid), {
    cacheTime: 0
});
